<!DOCTYPE html>
<html lang="de" data-theme="Code vibes theme">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Settings</title>
  <link rel="icon" type="image/svg+xml" href="/img/stadia-controller.svg">
</head>

<body>
  <main class="settings-main" aria-label="Settings page main content">
    <header class="settings-header">
      <h1 class="setting-h1">Settings</h1>
      <a href="./game.html" class="settings-back-button" data-back-to-game hidden>
        Back to game
      </a>
    </header>

    <section class="settings-content">
      <section class="settings-sidebar">
        <section aria-label="Theme selection">
          <div class="sub-headline-content">
            <img class="headline-icon" src="/img/palette.svg" alt="" aria-hidden="true">
            <p class="headline">Game Themes</p>
          </div>
          <fieldset class="input-content">
            <legend class="visually-hidden">Game themes</legend>
            <div class="input-container">
              <input type="radio" name="theme-radio-btn" id="theme-radio-btn-1" value="Code vibes theme">
              <label for="theme-radio-btn-1">Code vibes theme</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
            <div class="input-container">
              <input type="radio" name="theme-radio-btn" id="theme-radio-btn-2" value="Gaming theme">
              <label for="theme-radio-btn-2">Gaming theme</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
            <div class="input-container">
              <input type="radio" name="theme-radio-btn" id="theme-radio-btn-3" value="DA Projects theme">
              <label for="theme-radio-btn-3">DA Projects theme</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
          </fieldset>
        </section>

        <section aria-label="Player selection">
          <div class="sub-headline-content">
            <img class="headline-icon" src="/img/chess-pawn.svg" alt="" aria-hidden="true">
            <p class="headline">Choose player</p>
          </div>
          <fieldset class="input-content">
            <legend class="visually-hidden">Choose player</legend>
            <div class="input-container">
              <input type="radio" name="player-radio-btn" id="player-radio-btn-1" value="Blue">
              <label for="player-radio-btn-1">Blue</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
            <div class="input-container">
              <input type="radio" name="player-radio-btn" id="player-radio-btn-2" value="Orange">
              <label for="player-radio-btn-2">Orange</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
          </fieldset>
        </section>

        <section aria-label="Board size selection">
          <div class="sub-headline-content">
            <img class="headline-icon" src="/img/style.svg" alt="" aria-hidden="true">
            <p class="headline">Board size</p>
          </div>
          <fieldset class="input-content">
            <legend class="visually-hidden">Board size</legend>
            <div class="input-container">
              <input type="radio" name="board-size-radio-btn" id="board-size-radio-btn-1" value="16">
              <label for="board-size-radio-btn-1">16</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
            <div class="input-container">
              <input type="radio" name="board-size-radio-btn" id="board-size-radio-btn-2" value="24">
              <label for="board-size-radio-btn-2">24</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
            <div class="input-container">
              <input type="radio" name="board-size-radio-btn" id="board-size-radio-btn-3" value="36">
              <label for="board-size-radio-btn-3">36</label>
              <img class="label-icon" src="/img/line-short.svg" alt="" aria-hidden="true">
            </div>
          </fieldset>
        </section>
      </section>

      <section class="settings-content-panel">
        <section class="theme-section">
          <header>
            <div class="player-content">
              <img data-preview-player-icon="Blue" src="/img/label_blue.svg" alt="Blue marker">
              <p class="--label-blue --player-name">Blue</p>
              <p class="--label-blue">0</p>
              <img data-preview-player-icon="Orange" src="/img/label2.svg" alt="Orange marker">
              <p class="--label-orange --player-name">Orange</p>
              <p class="--label-orange">0</p>
            </div>
            <div class="current-player">
              <p>Current Player:</p>
              <div class="current-player-content-img">
                <img data-preview-current-player-icon src="/img/label_blue.svg" alt="Blue player icon">
              </div>
            </div>
            <div class="button-content">
              <div class="preview-exit-btn">
                <span class="preview-exit-btn-icon" aria-hidden="true"></span>
                <button type="button" disabled>Exit game</button>
              </div>
            </div>
          </header>
          <section id="theme-preview" class="theme-preview" aria-label="Theme preview cards">
            <img class="preview-card preview-card--2" src="" alt="Second preview card for the selected theme">
            <img class="preview-card preview-card--1" src="" alt="First preview card for the selected theme">
          </section>
        </section>

        <section class="settings-nav" aria-label="Current settings summary">
          <ul class="settings-nav__list">
            <li class="settings-nav__item" data-settings-nav="theme">
              <span>Theme </span><span class="settings-nav__value"></span>
            </li>
            <li class="settings-nav__item" data-settings-nav="player">
              <span>Player </span><span class="settings-nav__value"></span>
            </li>
            <li class="settings-nav__item" data-settings-nav="board-size">
              <span>Board </span><span class="settings-nav__value"></span>
            </li>
          </ul>
          <section class="setting-screen-buttons" aria-label="Start game action">
            <button type="button" class="button--settings" data-start-button disabled>Start</button>
            <img class="button-icons --controller" src="/img/smart_display.svg" alt="" aria-hidden="true">
          </section>
        </section>
      </section>
    </section>
  </main>

  <script type="module" src="/src/main.ts"></script>
</body>

</html>
